import { render, staticRenderFns } from "./404.vue?vue&type=template&id=06d0e726&scoped=true"
var script = {}
import style0 from "./404.vue?vue&type=style&index=0&id=06d0e726&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d0e726",
  null
  
)

export default component.exports